import moment from "moment";
import cancelPoliciesOptions from "../../../../constants/cancelPoliciesSelectsData.js";

const MOSCOW_OFFSET = 3;
const calculateSumBack = (
    condition,
    sumTotal,
    paidAmount,
    dateIn,
    dateOut,
    priceFirstDay,
) => {
    let sumBack;
    switch (condition.fine) {
        case "1": // Без штрафа (до даты)
            sumBack = paidAmount;
            break;
        case "2": // Удерживается стоимость первых суток
            sumBack = paidAmount - priceFirstDay;
            break;
        case "3": // Удерживается % от суммы брони
            sumBack =
                paidAmount - (paidAmount * parseInt(condition.percent)) / 100;
            break;
        default: // Невозвратный тариф
            sumBack = "0";
    }
    return sumBack;
};

export const logicOfPolicyChoice = (
    cancelPolicy,
    dateIn,
    dateOut,
    sumTotal,
    paidAmount,
    priceFirstDay,
) => {
    let index = 0;
    const conditions = cancelPolicy[0]?.conditions
        ? JSON.parse(cancelPolicy[0].conditions)
        : [];

    // Функция для получения текущего времени в Москве
    const getMoscowTime = () => {
        return moment().utcOffset(MOSCOW_OFFSET);
    };

    // Функция для преобразования даты в московское время
    const toMoscowTime = (date) => {
        return moment(date).utcOffset(MOSCOW_OFFSET);
    };

    // Условия по дате до заезда
    const options = conditions
        .filter((condition) => {
            const now = getMoscowTime(); // сегодня
            const isInAnyPeriod = condition.periods.some((period) => {
                const periodStart = toMoscowTime(period.start); // дата начала действия условия
                const periodEnd = toMoscowTime(period.end); // дата окончания действия условия
                return now >= periodStart && now <= periodEnd;
            });
            const dateInMoment = toMoscowTime(dateIn).set({
                hour: 15,
                minute: 0,
            }); // дата заезда
            const termDate = toMoscowTime(dateInMoment).subtract(
                condition.term,
                "days",
            ); // дата от которой активно условие

            return isInAnyPeriod && now >= termDate && !condition.fixDate;
        })
        .sort((a, b) => a.term - b.term) // Сортируем по term в порядке возрастания
        .slice(0, 1) // Берем только первый элемент (с минимальным term)
        .map((condition) => {
            const dateInMoment = toMoscowTime(dateIn).set({
                hour: 15,
                minute: 0,
            }); // дата заезда
            const termDate = toMoscowTime(dateInMoment).subtract(
                condition.term,
                "days",
            ); // дата до которой активно условие
            const deadline =
                " (действует c " + termDate.format("DD.MM.YYYY H:mm") + ")";
            const val = condition.fine + "_" + index;
            const label =
                condition.fine === "3"
                    ? cancelPoliciesOptions.fine[condition.fine].replace(
                          "%",
                          condition.percent + "%",
                      ) + deadline
                    : cancelPoliciesOptions.fine[condition.fine] + deadline;
            index++;
            return {
                val,
                label,
                sumBack: calculateSumBack(
                    condition,
                    sumTotal,
                    paidAmount,
                    dateIn,
                    dateOut,
                    priceFirstDay,
                ),
            };
        })

        .filter((condition) => condition.sumBack > 0);
    // Если не настало время действия условий. Берется ближайшее к настоящему времени условие "Без штрафа"
    const noPenaltyOptions = conditions
        .filter((condition) => {
            const now = getMoscowTime(); // сегодня
            const isInAnyPeriod = condition.periods.some((period) => {
                const periodStart = toMoscowTime(period.start); // дата начала действия условия
                const periodEnd = toMoscowTime(period.end); // дата окончания действия условия
                return now >= periodStart && now <= periodEnd;
            });
            const dateInMoment = toMoscowTime(dateIn).set({
                hour: 15,
                minute: 0,
            }); // дата заезда
            const termDate = toMoscowTime(dateInMoment).subtract(
                condition.term,
                "days",
            ); // дата от которой активно условие

            return (
                isInAnyPeriod &&
                now < termDate &&
                condition.fine === "1" &&
                !condition.fixDate
            );
        })
        .sort((a, b) => b.term - a.term) // Сортируем по term в порядке убывания
        .slice(0, 1) // Берем только первый элемент (с максимальным term)
        .map((condition) => {
            const val = condition.fine + "_" + index;
            const label = cancelPoliciesOptions.fine[condition.fine];
            index++;
            return {
                val,
                label,
                sumBack: calculateSumBack(
                    condition,
                    sumTotal,
                    paidAmount,
                    dateIn,
                    dateOut,
                    priceFirstDay,
                ),
            };
        })

        .filter((condition) => condition.sumBack > 0);
    // Условия от конкретной даты
    const additionalOptions = conditions
        .filter((condition) => {
            const now = getMoscowTime(); // сегодня
            const isInAnyPeriod = condition.periods.some((period) => {
                const periodStart = toMoscowTime(period.start); // дата начала действия условия
                const periodEnd = toMoscowTime(period.end); // дата окончания действия условия
                return now >= periodStart && now <= periodEnd;
            });
            const fixDate = toMoscowTime(condition.fixDate); // дата от которой активно условие

            return isInAnyPeriod && condition.fixDate && now >= fixDate;
        })
        .map((condition) => {
            const periodEnd = toMoscowTime(condition.periods[0].end); // дата окончания действия условия
            const deadline =
                " (действует до " + periodEnd.format("DD.MM.YYYY") + ")";
            const val = condition.fine + "_" + index;
            const label =
                condition.fine === "3"
                    ? cancelPoliciesOptions.fine[condition.fine].replace(
                          "%",
                          condition.percent + "%",
                      ) + deadline
                    : cancelPoliciesOptions.fine[condition.fine] + deadline;
            index++;
            return {
                val,
                label,
                sumBack: calculateSumBack(
                    condition,
                    sumTotal,
                    paidAmount,
                    dateIn,
                    dateOut,
                    priceFirstDay,
                ),
            };
        })
        .filter((condition) => condition.sumBack > 0);

    if (options?.length) {
        return options.concat(additionalOptions);
    } else {
        return noPenaltyOptions.concat(additionalOptions);
    }
};
